import App from "./App.svelte";
const app = new App({
    target: document.body,
    props: {
        title: "organoleptique​.email",
        subtitle: "A tasteful email newsletter.",
        twitter: "organoleptique",
        date: "Coming soon",
    },
});
export default app;
